import * as React from "react";

const SmallLogo = (props) => (
  <svg
    width={38}
    height={38}
    viewBox="0 0 55.8936614148944 55.22823094067096"
    className="css-1j8o68f"
    {...props}
  >
    <defs id="SvgjsDefs5399">
      <linearGradient id="SvgjsLinearGradient5408">
        <stop id="SvgjsStop5409" stopColor="#00ff8f" offset={0} />
        <stop id="SvgjsStop5410" stopColor="#00a1ff" offset={1} />
      </linearGradient>
      <linearGradient id="SvgjsLinearGradient5411">
        <stop id="SvgjsStop5412" stopColor="#00ff8f" offset={0} />
        <stop id="SvgjsStop5413" stopColor="#00a1ff" offset={1} />
      </linearGradient>
    </defs>
    <g
      id="SvgjsG5400"
      featurekey="symbolFeature-0"
      transform="matrix(0.00601033498489887,0,0,0.00601033498489887,-3.005167492449435,-5.938210965080083)"
      fill="url(#SvgjsLinearGradient5408)"
    >
      <defs xmlns="http://www.w3.org/2000/svg" />
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          className="fil0"
          d="M6669 6442l-2652 0c-158,176 -347,379 -523,578 -399,451 -1334,822 -1470,858 -136,36 -499,18 -281,-235 218,-253 435,-903 435,-1201l-626 0c-578,0 -1052,-471 -1052,-1048l0 -3359c0,-576 474,-1047 1052,-1047l5117 0c579,0 1053,471 1053,1047l0 3359c0,577 -474,1048 -1053,1048zm-780 -3287c-280,0 -508,226 -508,506 0,279 228,505 508,505 281,0 508,-226 508,-505 0,-280 -227,-506 -508,-506zm-1742 54c-280,0 -508,227 -508,506 0,279 228,506 508,506 281,0 508,-227 508,-506 0,-279 -227,-506 -508,-506zm-1742 54c-280,0 -508,227 -508,506 0,279 228,506 508,506 281,0 508,-227 508,-506 0,-279 -227,-506 -508,-506zm6115 -523l-149 0c6,41 9,83 9,126l0 3197c0,536 -441,975 -980,975l-3090 0c-201,218 -538,583 -538,583 0,0 108,266 448,266l2712 0c103,328 379,603 563,745 200,153 549,365 839,379 290,13 322,-81 272,-145 -50,-63 -195,-406 -254,-560 -38,-99 -34,-294 -27,-419l195 0c539,0 980,-439 980,-976l0 -3196c0,-537 -441,-975 -980,-975z"
          style={{
            fill: "url(#SvgjsLinearGradient5408)",
          }}
        />
      </g>
    </g>
  </svg>
);

export default SmallLogo;
